import { App, AppState } from "@capacitor/app";
import { Network, NetworkStatus } from "@capacitor/network";

export const networkCheck = (props: any) => {
    App.addListener("appStateChange", (state: AppState) => {
      // state.isActive contains the active state
      if (state.isActive) {
        updateNetworkStatus(props);
      }
    });
  
    /* handler to check network status change */
    Network.addListener("networkStatusChange", (_netStatus: NetworkStatus) => {
      props.updateNetworkStatus(_netStatus);
    });
    updateNetworkStatus(props);
  };
  
  //  checks network status  and update in redux store.
  const updateNetworkStatus = (props: any) => {
    Network.getStatus().then((status: NetworkStatus) => {
      props.updateNetworkStatus(status);
    });
  };